import { ReactNode } from 'react';

import { Box } from '../../chakra';

export interface PageHeaderProps {
  children: ReactNode;
}

/**
 * Wrapper for the page title (use `PageTitle`) and any other header content,
 * which provides standard spacing from the actual content below
 */
export function PageHeader({ children }: PageHeaderProps) {
  return <Box paddingBottom={6}>{children}</Box>;
}
